import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';
import { dispatch } from 'redux_data/store';
import { getFirstAndLastDateOfWeek } from 'utils/util'; 

const [start_date , end_date] = getFirstAndLastDateOfWeek();
const slice = createSlice({
  name: 'marketplace_order', // This is the name of the slice
  initialState: {
    hasError: null,
    isLoading: false,
    isLoadingDetail: false,
    start_date: start_date, 
    end_date: end_date,
    account_code:"-",
    order_status:"-",
    post_status:"-",
    payout_status:"-",
    datas: [],
    // successAutoPull: 0,
    // failedAutoPull: 0,
    // successManualPull: 0,
    // failedManualPull: 0,
  },
  reducers: {
    noError(state) { // NO ERROR
      state.hasError = false;
    },
    unsetError(state) { // UNSET ERROR
      state.hasError = null;
    },
    hasError(state, action) { // HAS ERROR
      state.isLoading = false;
      state.hasError = JSON.stringify(action.payload);
    },
    startLoading: (state, action) => {
      state.isLoading = true;
    },
    startLoadingDetail: (state, action) => {
      state.isLoadingDetail = true;
    },
    setDatas: (state, action) => {
      state.isLoading = false;
      state.datas = action.payload;
    },
    setStartDate: (state, action) => {
      state.isLoading = false;
      state.start_date = action.payload;
    },
    setEndDate: (state, action) => {
      state.isLoading = false;
      state.end_date = action.payload;
    },
    setOrderStatus: (state, action) => {
      state.isLoading = false;
      state.order_status = action.payload;
    },
    setAccountCode: (state, action) => {
      state.isLoading = false;
      state.account_code = action.payload;
    },
    setPostStatus: (state, action) => {
      state.isLoading = false;
      state.post_status = action.payload;
    },
    setPayoutStatus: (state, action) => {
      state.isLoading = false;
      state.payout_status = action.payload;
    },

    // setSuccessAutoPull: (state, action) => {
    //   state.isLoading = false;
    //   state.successAutoPull = action.payload;
    // },
    // setFailedAutoPull: (state, action) => {
    //   state.isLoading = false;
    //   state.failedAutoPull = action.payload;
    // },
    // setSuccessManualPull: (state, action) => {
    //   state.isLoading = false;
    //   state.successManualPull = action.payload;
    // },
    // setFailedManualPull: (state, action) => {
    //   state.isLoading = false;
    //   state.failedManualPull = action.payload;
    // },
  },
});

export const { 
    noError , 
    unsetError , 
    hasError, 
    startLoading , 
    startLoadingDetail , 
    setStartDate ,
    setEndDate ,
    setOrderStatus,
    setAccountCode,
    setPostStatus,
    setPayoutStatus,
} = slice.actions;


const endpoint = "/marketplace_order"

export function searchData({ data = {} , params = {} } = {data: {} , params: {}}) {
  return async (dispatch , getState) => {
    dispatch(slice.actions.startLoading());
    try {
      let endpointURL = `${endpoint}/search`;
      Object.keys(params).forEach(key => {
        if(endpointURL.includes("?")){
          endpointURL = `${endpointURL}&${key}=${params[key]}`;
        }else{
          endpointURL = `${endpointURL}?${key}=${params[key]}`;
        }
      })

      const currentState = getState();
      
      if(!(data?.start_date)){ data.start_date = currentState.marketplace_order.start_date }
      if(!(data?.end_date)){ data.end_date = currentState.marketplace_order.end_date }

      const response = await axios.post( endpointURL , data )?.then( resp => resp?.data);
      if(response?.success){
        dispatch(slice.actions.setDatas(response.data));
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function postData({ data = {} , params = {} } = {data: {} , params: {}}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      // let endpointURL = `${endpoint}/post_sales_data`;
      let endpointURL = `/marketplace_push_order/post_sales_data`;
      Object.keys(params).forEach(key => {
        if(endpointURL.includes("?")){
          endpointURL = `${endpointURL}&${key}=${params[key]}`;
        }else{
          endpointURL = `${endpointURL}?${key}=${params[key]}`;
        }
      })
      const response = await axios.post( endpointURL , data )?.then( resp => resp?.data);
      // console.log("postData", response);
      if(response?.success){
        dispatch(slice.actions.noError());
        dispatch(searchData());
      }else{
        if(response?.data){
          dispatch(hasError(response.data));
        }else{
          dispatch(hasError(response));
        }
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function pullData({data}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${endpoint}/`, data )?.then( resp => resp?.data);
      // console.log("pullData", response);
      if(response?.success){
        dispatch(slice.actions.noError());
        // dispatch(searchData());
      }else{
        if(response?.data){
          dispatch(hasError(response.data));
        }else{
          dispatch(hasError(response));
        }
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function editData({id, formData, encryptedPin}) {
  return async (dispatch , getState) => {
    dispatch(slice.actions.startLoading());
    try {
      if(encryptedPin){ axios.defaults.headers.common.pin = encryptedPin; }
      const response = await axios.patch(`${endpoint}/${id}`, formData )?.then( resp => resp?.data);
      // console.log("editData", response);
      
      if(response?.success){
        dispatch(slice.actions.noError());
        dispatch(searchData());
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function editDataBulk({ formData}) {
  return async (dispatch , getState) => {
    dispatch(slice.actions.startLoading());
    try {
      // if(encryptedPin){ axios.defaults.headers.common.pin = encryptedPin; }
      const response = await axios.patch(`${endpoint}/bulk`, formData )?.then( resp => resp?.data);
      // console.log("editData", response);
      
      if(response?.success){
        dispatch(slice.actions.noError());
        dispatch(searchData());
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function deleteData({list_id , encryptedPin}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      // console.log(list_id , encryptedPin);
      if(encryptedPin){ axios.defaults.headers.common.pin = encryptedPin; }
      const response = await axios.put(`${endpoint}/` , {id:list_id});
      if(response?.data?.success){
        dispatch(slice.actions.noError())
        dispatch(searchData());
      }else{
        dispatch(slice.actions.hasError(response?.data));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export default slice.reducer;
